import { Link } from "react-router-dom";
import { Button } from "primereact/button";

import { Paths } from "@/core/constants/paths";
import styles from "./forbidden-screen.module.scss";

export function ForbiddenScreen() {
  return (
    <main className={styles.container} data-testid="forbidden-screen">
      <i className={`pi pi-lock ${styles.icon}`} aria-hidden />
      <h1 className={styles.title}>Acesso não autorizado</h1>
      <p className={styles.description}>
        Você não tem permissão para acessar esta página. Caso precise deste acesso, procure o
        administrador do Hub.
      </p>
      <Link to={Paths.HOME}>
        <Button
          type="button"
          className={styles.homeButton}
          label="Voltar para o início"
          icon="pi pi-home"
          data-testid="forbidden-home-link"
        />
      </Link>
    </main>
  );
}
